import { Component, EventEmitter, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { PrescriptionRequestStatusEnum } from 'src/app/enums/prescription-request-status-enum';
import { RequestStatusTypeEnum } from 'src/app/enums/request-status-type-enum';
import { showNotification } from 'src/app/helpers/show-toast';
import { PrescriptionService } from 'src/app/_services/prescription-fulfillment/prescription.service';

@Component({
  selector: 'app-lab-tests-status-modal',
  templateUrl: './lab-tests-status-modal.component.html',
  styleUrls: ['./lab-tests-status-modal.component.scss'],
})
export class LabTestsStatusModalComponent implements OnInit {
  requestId;
  requestStatus: number;
  prescriptionRequestStatusEnum = PrescriptionRequestStatusEnum;
  isInProgress: boolean = false;
  public event: EventEmitter<any> = new EventEmitter();

  constructor(
    public bsModalRef: BsModalRef,
    private toastr: ToastrService,
    private prescriptionService: PrescriptionService
  ) {}

  ngOnInit(): void {
    this.isInProgress =
      this.requestStatus == this.prescriptionRequestStatusEnum.InProgress
        ? true
        : false;

    this.requestStatus = this.isInProgress
      ? this.prescriptionRequestStatusEnum.Finished
      : this.prescriptionRequestStatusEnum.InProgress;
  }

  onStatusChange(value) {
    this.requestStatus = value;
  }

  onLabTestsStatusSubmit() {
    this.prescriptionService
      .updateRequestStatus(
        +this.requestId,
        this.requestStatus,
        RequestStatusTypeEnum.LabTests
      )
      .subscribe((response) => {
        if (response?.data) {
          this.event.emit({
            requestStatus: this.requestStatus,
            data: response.data
          });
          showNotification(
            'success',
            'The request status has been updated successfully.',
            this.toastr
          );
        }
      });

    this.bsModalRef.hide();
  }
}
